module.exports = __webpack_public_path__ + "static/img/Samsara Agung-close.6e17b19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/closeup/Samsara Agung-close.jpg
// module id = Rm8r
// module chunks = 1